import "./Experience.css";

const Experience = () => {
  return (
    <div className="experience" id="Experience">
      <div className="achievement">
        <div className="circle">1+</div>
        <span>years</span>
        <span>Experience</span>
      </div>
      <div className="achievement">
        <div className="circle">10+</div>
        <span>Completed</span>
        <span>Projects</span>
      </div>
      <div className="achievement">
        <div className="circle">1+</div>
        <span>Companies</span>
        <span>work</span>
      </div>
    </div>
  );
};

export default Experience;
